module.exports = __webpack_public_path__ + "img/menes-energies.3df587c3.png";